var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', {
    class: ['blinking-cursor-text', _vm.className, !_vm.textSelectableAfterTyping ? 'noselect' : '', _vm.isCompletedStep ? 'text-completed' : ''],
    attrs: {
      "data-text": _vm.text
    }
  }, _vm._l(_vm.splitWords, function (word, i) {
    return _c('span', {
      key: i,
      staticClass: "word",
      attrs: {
        "data-word": word.text
      }
    }, _vm._l(word.text, function (letter, j) {
      return _c('span', {
        key: letter + word.startingIndex + j,
        class: _vm.getClasses(word.startingIndex + j, letter),
        staticStyle: {
          "position": "relative"
        },
        attrs: {
          "aria-live": _vm.isCurrentCharacter(word.startingIndex + j) ? 'assertive' : null,
          "role": _vm.isCurrentCharacter(word.startingIndex + j) ? 'input' : null,
          "tabindex": _vm.isCurrentCharacter(word.startingIndex + j) ? 0 : -1
        }
      }, [_vm._v(_vm._s(letter))]);
    }), 0);
  }), 0);
}
var staticRenderFns = []

export { render, staticRenderFns }